<script>
import Base from '@backend/Base.vue';
import BOGen from '@helper/BOGen.js';
import VueHtml2pdf from 'vue-html2pdf';
import TableChecklist from '@backend/components/TableChecklist.vue'

export default {
  extends: Base,
  components: {
    VueHtml2pdf,
    TableChecklist
  },
  data() {
    return {
      Name: "OnboardingChecklist",
      PageName: "Onboarding Checklist List",
      ObjectName: "Onboarding Checklist",
      WithLimit: true,
      AddItem: false,
      filter: {},
      statusKey: "",

      dataModal: {},
      loading: {
        checklist: false,
        exportPdf: false,
        submitChecklist: false
      },

      export_fields: {
        'Employee Name': 'employee_name',
        'Employee CWID': 'employee_cwid',
        'Effective Join Date': 'effective_join_date',
        'Type': 'type',
        'Status': 'status',
      },

      export_data: [],
      mrValidation: {},

      // data options
      mrFormChecklist: [],
      mrFormChecklistAll: [],
      durationTypeOptions: {
        "M": "Minute",
        "H": "Hour",
        "D": "Day",
        "W": "Week",
        "MH": "Month",
      },

      // -- end data options
    }
  },
  mounted() {
    this.$set(this.$root, 'page', this)
    this.refreshData()
  },
  methods: {
    setValidate(e, key){
      if(e.target.checked){
        let newValidation = {
          ...this.mrValidation,
          [key]: 'required'
        }
        this.$set(this, 'mrValidation', newValidation)
      } else {
        delete this.mrValidation[key]
      }
    },
    setMrValidation(delay = 1000, checklist){
      setTimeout(() => {
        let newValidation = {
          ...this.mrValidation
        }

        // Add Validation Rules Sub Item Checklist
        checklist.map((c, kChecklist) => {
          return c.items.map((item, kItem) => {
            return item.subItems.forEach((si, kSubItem) => {
              Object.assign(newValidation, { 
                [`remarks${kChecklist}${kItem}${kSubItem}`]: 'required',
              })
            })
          })
        })

        this.$set(this, 'mrValidation', newValidation)
    
      }, delay)
    },
    formName(formID) {
      const selectedForm = this.mrFormChecklistAll.find(fc => fc.value == formID)
      return selectedForm ? selectedForm.label : ""
    },
    isYourChecklist(verificatorCWID) {
      return verificatorCWID === this.user.cwid
    },
    durationType(type) {
      return this.durationTypeOptions[type] || ""
    },
    removeDataModal() {
      this.$set(this, 'dataModal', {})
    },
    openDetailChecklist(data) {
      this.removeDataModal()      

      this.getChecklistData(data.ac_id, data)
      $("#DetailChecklist").modal({
        backdrop: 'static',
        keyboard: false
      })
    },
    openPreviewExport(data) {
      this.removeDataModal()

      this.getChecklistData(data.ac_id, data)
      $("#ExportPDF").modal({
        backdrop: 'static',
        keyboard: false
      })
    },

    // Export PDF 
    exportToPdf() {
      this.$set(this.loading, 'exportPdf', true)
      this.$refs.reportChecklist.generatePdf()
    },

    onProgress(e) {
      if (e >= 100) this.$set(this.loading, 'exportPdf', false)
    },

    hasStartedGeneration() {
      this.$set(this.loading, 'exportPdf', true)
    },

    hasGenerated(e) {
      this.$set(this.loading, 'exportPdf', false)
    },

    // -- End Method Export PDF

    // Hit API
    getChecklistData(id, data) {
      // this.loadingOverlay = true
      this.$set(this.loading, 'checklist', true)
      BOGen.apirest(`/OnboardingChecklist/${id}`, {}, (err, resp) => {
        this.$set(this.loading, 'checklist', false)
        // this.loadingOverlay = false
        if (err) return console.error(err)

        const {
          row,
          checklist,
          mrFormChecklist,
          mrFormChecklistAll,
        } = resp

        this.$set(this, 'mrFormChecklist', mrFormChecklist)
        this.$set(this, 'mrFormChecklistAll', mrFormChecklistAll)
        this.$set(this, 'dataModal', {
          cwid: row.ac_cwid,
          employeename: row.ac_employeename,
          employee_position: row.ac_employee_position,
          effective_join_date: row.ac_effective_join_date,
          is_fix_checklist: row.ac_is_fix_checklist,
          form_id: row.ac_mfc_id || 0,
          checklist_id: row.ac_id,
          title_form: row.title_form,
          description_form: row.description_form,
          description_form_en: row.description_form_en,
          is_completed: data.is_completed,
          checklist
        })
      })
    },

    generateChecklistForm() {
      this.$set(this.loading, 'checklist', true)
      BOGen.apirest(`/OnboardingChecklist/get-checklist-data/${this.dataModal.checklist_id}/${this.dataModal.form_id}`, {}, (err, resp) => {

        this.$set(this.loading, 'checklist', false)
        if (err) return console.error(err)

        const {
          checklist
        } = resp
        this.$set(this, 'dataModal', {
          ...this.dataModal,
          checklist
        })
      })
    },

    submitChecklist(data) {
      const newChecklist = []

      // Push only activity/subitem
      data.checklist.forEach(c => {
        return c.items.forEach(item => {
          return item.subItems.forEach(si => {
            const keySubItems = Object.keys(si)
            const objChecklist = {}

            keySubItems.forEach(key => {
              return Object.assign(objChecklist, {
                [`aca_${key}`]: si[key]
              })
            })

            newChecklist.push(objChecklist)
          })
        })
      })

      const filteredChecklist = newChecklist.filter(checklist => {
        if (data.is_fix_checklist) return this.isYourChecklist(checklist.aca_verificator_cwid)
        return true
      })

      BOGen.apirest("/" + this.Name + "/submit-checklist", {
        checklist: filteredChecklist,
        ac_mfc_id: data.form_id,
        ac_id: data.checklist_id
      }, (err, resp) => {
        if (err) {
          console.log(err)
          return
        }
        // callback change status
        swal("Success!", "Checlist successfully submitted.", "success")
          .then(() => {
            $("#DetailChecklist").modal("hide")
            this.removeDataModal()
            this.refreshData()
          });
      }, "POST")

    },

    changeForm(data) {
      swal({
        title: "Are You Sure to Change the Form?",
        text: "All proggress that done before will be remove permanently.",
        icon: "warning",
        buttons: ["No, Cancel!", "Yes, Change It!"],
        // dangerMode: true,
      }).then((ok) => {
        if (ok) {

          BOGen.apirest("/" + this.Name + "/change-form", {
            ac_id: data.checklist_id
          }, (err, resp) => {
            if (err) {
              console.log(err)
              return
            }
            // callback change status
            swal("Success!", "Successfully Change Form.", "success")
              .then(() => {
                this.getChecklistData(data.checklist_id, { ...this.dataModal })
              });
          }, "POST")
        }
      });
    }

    // --End Hit
  },
  watch: {
    '$route.query'(v) {
      this.refreshData()
    },
  },
  computed: {
    dateNow(){
      const today = new Date();
      return today.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        format: "DD_MM_YYYY",
      });
    }
  }
}
</script>

<style scoped>
tr.item-centered td {
  vertical-align: middle;
  text-align: center;
}

thead.head-checklist {
  background: #203764;
  border: 1px solid #203764 !important;
  color: #FFF !important;
}

thead.head-checklist th {
  border: 1px solid #203764 !important;
  color: #FFF !important;
}

button:disabled {
  opacity: .7 !important;
  cursor: auto !important;
}

div.vue-html2pdf {
  position: absolute !important;
  top: -1000em !important;
}

table tr.activity_done {
  background: rgba(206, 255, 204, .6) !important;
}
</style>

<template>
<div class="container-fluid">
  <PageTitle :listOnly="$route.meta.listOnly"></PageTitle>

  <!-- ======================================================================== 
      LIST DATA
    ============================================================================= -->
  <div class="card card-flat" v-if="!$route.params.id">
    <div class="card-body card-filter">
      <VForm @resp="search">
        <div class="row">
          <div class="col-sm-3">
            <h4 class="card-title">{{ObjectName}} List <span v-if="data.total">({{(data.total||0).format()}})</span></h4>
          </div>
          <div class="col-sm-1">
            <Select2 :options="BoConfig.mrPageLimit" v-model="filter.limit" @input="changeLimit"></Select2>
          </div>
          <div class="col-sm-2">
            <Select2 :options="BoConfig.mrTypeChecklist" v-model="filter.type" @input="filterStatus">
              <option value="">-- Select Checklist Type --</option>
            </Select2>
          </div>
          <div class="col-sm-3">
            <div class="has-feedback has-feedback-left">
              <input type="search" v-model="filter.search" @keyup.enter="search" class="form-control" placeholder="Type and hit Enter">
              <div class="form-control-feedback">
                <i class="icon-search4 text-size-base text-muted"></i>
              </div>
            </div>
          </div>
          <div class="col-sm-1">
            <button type="button" @click="resetSearch()" class="btn btn-warning btn-sm">Reset</button>
          </div>

          <div class="col-sm-2 justify-content-center">
            <div class="w-100 text-center">
              <download-excel class="fcbtn btn btn-success btn-outline btn-1e btn-loading" 
                :data="export_data" :fields="export_fields" type="xls"
                worksheet="My Worksheet" :name="`onboardingChecklist_${dateNow}.xls`"
              >
                Export to Excel <i class="ml-3 ti-export"></i>
              </download-excel>
            </div>
          </div>
        </div>
      </VForm>
    </div>
    <div class="table-responsive ajax-table">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th width="50px">#</th>
            <th>Employee Name</th>
            <th>Effective Join Date</th>
            <th>Type</th>
            <th>Status</th>
            <th width="120px">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(v,k) in data.data" :key="k">
            <td class="number">{{(data.per_page*(data.current_page-1))+k+1}}</td>
            <td>
              <p class="mb-0">{{v.ac_employeename||"-"}}</p>
              <small>({{ v.ac_cwid }})</small>
            </td>
            <td>{{ moment(v.ac_effective_join_date).format('DD MMM YYYY') }}</td>
            <td>
              <StatusLabel :status="v.ac_type" type="onboardingChecklist"></StatusLabel>
            </td>
            <td>
              <label class="label label-success" v-if="v.is_completed">Completed</label>
              <label class="label label-danger" v-else>Not Complete</label>
            </td>
            <td class="btn-action">
              <a href="javascript:;" class="icon_action" @click="openDetailChecklist(v)" v-tooltip="'Checklist'" v-if="v.ac_is_fix_checklist || (!v.ac_is_fix_checklist && v.ac_cwid_manager == user.cwid)">
                <i class="icon-settings"></i>
              </a>
              <a href="javascript:;" class="icon_action" @click="openPreviewExport(v)" v-tooltip="'Export to PDF'" v-if="v.ac_mfc_id"><i class="ti-export"></i></a>

              <span class="text-center" v-if="(!v.ac_is_fix_checklist && v.ac_cwid_manager != user.cwid)">
                Form is not selected
              </span>
            </td>
          </tr>
          <tr v-if="NotFound">
            <td colspan="99">
              <h3 class="tc">{{NotFound}}</h3>
            </td>
          </tr>
          <tr v-if="data.data===false">
            <td colspan="99">
              <LoadingSpinner light></LoadingSpinner>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="card-body">
      <div class="pull-right">
        <Pagination :data="data" :limit="3" @pagination-change-page="onPaging"></Pagination>
      </div>
    </div>
  </div>

  <div id="DetailChecklist" class="modal" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-lg" style="max-width: 80%;">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="myLargeModalLabel">Detail Checklist</h4>
        </div>
        
        <VForm @resp="submitChecklist(dataModal)" method="post">
          <div class="modal-body">
            <div class="row">
              <div :class="{'col-md-12': !dataModal.is_fix_checklist,'col-md-8': dataModal.is_fix_checklist}">
                <template v-if="!dataModal.is_fix_checklist">
                  <div class="form-group">
                    <label>Select Form</label>
                    <select v-model="dataModal.form_id" class="form-control" @change="generateChecklistForm()" :disabled="loading.checklist">
                      <option value="0" hidden selected>-- Form --</option>
                      <option :value="form.value" v-for="(form, kForm) in mrFormChecklist" :key="kForm">
                        {{ form.label }}
                      </option>
                    </select>
                  </div>
                </template>

                <template v-else>
                  <div>
                    <span>Form Checklist Name</span>
                    <h5 class="font-weight-bold">{{ formName(dataModal.form_id) }}</h5>
                  </div>
                </template>
              </div>

              <div class="col-md-4 text-right" v-if="dataModal.is_fix_checklist && !dataModal.is_completed">
                <button type="button" class="btn btn-info" @click="changeForm(dataModal)">Change Form</button>
              </div>
            </div>

            <template v-if="dataModal.form_id && !loading.checklist">
              <hr />
              <h4 class="font-weight-bold mt-3">Checklist</h4>
              <table class="table table-striped table-bordered mt-3">
                <tbody>
                  <tr>
                    <td style="width: 20%">Nama (CWID)</td>
                    <td colspan="2">
                      : <strong>{{ dataModal.employeename }} ({{ dataModal.cwid }})</strong>
                    </td>
                  </tr>

                  <tr>
                    <td style="width: 20%">Job Position</td>
                    <td colspan="2">
                      : <strong>{{ dataModal.employee_position }}</strong>
                    </td>
                  </tr>

                  <tr>
                    <td style="width: 20%">Effective Join Date</td>
                    <td colspan="2">
                      : <strong>{{ moment(dataModal.effective_join_date).format('DD MMM YYYY') }}</strong>
                    </td>
                  </tr>
                </tbody>

              </table>
              <!-- Table Checklist -->
              <table class="table table-striped table-bordered" v-for="(dataChecklist, kChecklist) in dataModal.checklist" :key="kChecklist">
                <thead>
                  <tr>
                    <th colspan="5" style="background:#bde0ff;">
                      <div class="row justify-content-center pt-3 pb-3">
                        <div class="col-md-4">
                          <div class="text-center">
                            <h6 class="font-weight-bold mb-0">{{ dataChecklist.title }}</h6>
                          </div>
                        </div>
                      </div>
                    </th>
                  </tr>

                </thead>

                <tbody v-for="(dataItemChecklist, kItemChecklist) in dataChecklist.items" :key="kItemChecklist">
                  <tr style="background:#f2f2f2;">
                    <th style="vertical-align:middle;" colspan="2">
                      <p class="text-center font-weight-bold mb-0">{{ dataItemChecklist.title }}</p>
                    </th>

                    <th style="vertical-align:middle;">
                      <p class="text-center font-weight-bold mb-0">Duration</p>
                    </th>

                    <th style="vertical-align:middle;">
                      <p class="text-center font-weight-bold mb-0">Responsible</p>
                    </th>

                    <th style="vertical-align:middle;">
                      <p class="text-center font-weight-bold mb-0">Complete Date</p>
                    </th>
                  </tr>

                  <tr v-for="(dataItemSubChecklist, kItemSubChecklist) in dataItemChecklist.subItems" :key="kItemSubChecklist" class="item-centered" :class="{'activity_done': dataItemSubChecklist.done_date && dataItemSubChecklist.is_done}">
                    <td style="width:5%;">
                      <input v-if="!dataItemSubChecklist.done_date" class="form-check-input" type="checkbox" :id="`done${kChecklist}${kItemChecklist}${kItemSubChecklist}`" v-model="dataItemSubChecklist.is_done" style="transform:translate(1em, -.75em);" :disabled="!isYourChecklist(dataItemSubChecklist.verificator_cwid)" @click="setValidate($event, `remarks${kChecklist}${kItemChecklist}${kItemSubChecklist}`)">

                      <p class="text-center mb-0" v-else>✔</p>
                    </td>
                    <td style="text-align: left;">
                      <p class="mb-0" style="text-align: center;">{{ dataItemSubChecklist.name }}</p>
                      <p class="mb-0" style="text-align: center;" v-if="dataItemSubChecklist.name_en">({{ dataItemSubChecklist.name_en }})</p>

                      <template v-if="!dataItemSubChecklist.done_date">
                        <template v-if="isYourChecklist(dataItemSubChecklist.verificator_cwid) && dataItemSubChecklist.using_remarks">
                          <hr>
                          <BoField :name="`remarks${kChecklist}${kItemChecklist}${kItemSubChecklist}`" :noLabel="true" :mandatory="true">
                            <textarea 
                              :name="`remarks${kChecklist}${kItemChecklist}${kItemSubChecklist}`" 
                              class="form-control mt-3" rows="2" 
                              placeholder="Remarks..." v-model="dataItemSubChecklist.remarks" 
                              v-bind="validation(`remarks${kChecklist}${kItemChecklist}${kItemSubChecklist}`)"
                              :disabled="!dataItemSubChecklist.is_done"
                            ></textarea>
                          </BoField>
                        </template>
                      </template>

                      <template v-else>
                        <template v-if="dataItemSubChecklist.remarks">
                          <hr>
                          <span style="text-align: left !important;"><strong>Remarks: </strong> {{ dataItemSubChecklist.remarks }}</span>
                        </template>
                      </template>
                    </td>

                    <td>
                      <div class="text-center" v-if="dataItemSubChecklist.using_duration">
                        <p class="mb-0">{{ dataItemSubChecklist.duration }} {{ durationType(dataItemSubChecklist.duration_type) }}</p>
                      </div>

                      <template v-else>
                        <p class="mb-0">N/A</p>
                      </template>
                    </td>

                    <td>
                      <p class="text-center mb-0">
                        {{ dataItemSubChecklist.verificator_name }}
                      </p>
                    </td>

                    <td>
                      <p class="mb-0 text-center" v-if="dataItemSubChecklist.done_date">{{ moment(dataItemSubChecklist.done_date).format('DD MMM YYYY') }}</p>
                      <p class="mb-0 text-center" v-else>-</p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- End Table Checlist -->
            </template>

            <div class="row justify-content-center" v-else>
              <div class="col-md-8 mt-3">
                <template v-if="!loading.checklist">
                  <h5 class="font-weight-bold text-center">
                    Please Select Form First.
                  </h5>
                  <p class="text-center mb-0">
                    To display the checklist, please select the form first, if there is something that does not match the checklist data, please check the master data inputted.
                  </p>
                </template>

                <template v-else>
                  <p class="mb-2">
                    <LoadingSpinner light></LoadingSpinner>
                  </p>

                  <h5 class="font-weight-bold text-center">Loading</h5>
                </template>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-invers waves-effect text-left" data-dismiss="modal" @click="removeDataModal">Close</button>
            <button type="submit" class="btn btn-info waves-effect text-left" :disabled="loading.submitChecklist || !dataModal.form_id">
              <template v-if="loading.submitChecklist">
                <LoadingSpinner />
              </template>

              <template v-else>
                Submit
              </template>
            </button>
          </div>
        </VForm>
      </div>
    </div>
  </div>

  <div id="ExportPDF" class="modal" data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-lg" style="max-width: 80%;">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="myLargeModalLabel">Preview</h4>
        </div>
        <div class="modal-body">
          <TableChecklist :dataModal="dataModal" />
        </div>

        <!-- HTML to PDF -->
        <div>
          <vue-html2pdf :show-layout="false" :float-layout="false" :enable-download="true" :preview-modal="false" :paginate-elements-by-height="800" :filename="`checklist_${dataModal.employeename}`" :pdf-quality="2" :manual-pagination="false" pdf-format="a4" pdf-orientation="landscape" pdf-content-width="1100px" @progress="onProgress($event)" @hasStartedGeneration="hasStartedGeneration()" @hasGenerated="hasGenerated($event)" ref="reportChecklist">
            <slot slot="pdf-content">
              <div class="ml-3">
                <TableChecklist :dataModal="dataModal" />
              </div>
            </slot>
          </vue-html2pdf>
        </div>
        <!-- End HTML to PDF -->

        <div class="modal-footer">
          <button type="button" class="btn btn-invers waves-effect text-left" data-dismiss="modal" @click="removeDataModal">Close</button>
          <button type="button" class="btn btn-info waves-effect text-left" @click="exportToPdf" :disabled="loading.exportPdf">
            <template v-if="loading.exportPdf">
              <LoadingSpinner />
            </template>

            <template v-else>
              Export to Pdf
            </template>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
